import { useBreakpoint } from '@ocean/hooks'
import { useMobile } from 'hooks'
import { LayoutProps, AppLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import {
  Root,
  BannerSection,
  ContentWrapper,
  Content,
  Sidebar,
  SidebarInsides,
  Mobilebar,
} from './AppLayout.styled'

export type AppLayoutSegments = 'sidebar' | 'content' | 'mobilebar' | 'banner'
type InternalLayoutProps = LayoutProps<AppLayoutSegments>

export const AppLayoutSegment: React.FC<AppLayoutSegmentProps> = ({ children }) => <>{children}</>

const AppLayout = ({ segments }: InternalLayoutProps) => {
  const isDesktopDevice = useBreakpoint('sm')
  const isMobileDevice = useMobile()
  const isDesktop = isDesktopDevice && !isMobileDevice
  const { banner, sidebar, mobilebar, content } = segments || {}

  return (
    <Root isDesktop={isDesktop}>
      {sidebar && isDesktop && (
        <Sidebar>
          <SidebarInsides>{sidebar}</SidebarInsides>
        </Sidebar>
      )}
      <ContentWrapper>
        <BannerSection>{banner}</BannerSection>
        <Content>{content}</Content>
      </ContentWrapper>
      {mobilebar && !isDesktop && <Mobilebar isDesktop={isDesktop}>{mobilebar}</Mobilebar>}
    </Root>
  )
}

export default withLayout(AppLayout)
